import type { ReactNode } from 'react';
import React, { useEffect, useState } from 'react';

import * as styles from './Tabs.styles';

interface Tab {
  content: ReactNode;
  id: string;
  label: string;
}

interface TabsProps {
  ariaLabel?: string;
  tabs: Tab[];
}

export const Tabs = ({ ariaLabel, tabs }: TabsProps) => {
  const [currentHash, setCurrentHash] = useState('');

  useEffect(() => {
    const syncHash = () => {
      setCurrentHash(window.location.hash);
    };

    syncHash();
    window.addEventListener('hashchange', syncHash);

    return () => {
      window.removeEventListener('hashchange', syncHash);
    };
  }, []);

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/no-noninteractive-element-to-interactive-role */}
      <nav aria-label={ariaLabel} css={styles.tabList} role="tablist">
        {tabs.map((tab) => {
          const isActive = currentHash ? currentHash === `#${tab.id}` : tab.id === tabs[0]?.id;
          return (
            <a
              aria-controls={`panel-${tab.id}`}
              aria-current={isActive ? 'page' : undefined}
              aria-selected={isActive}
              css={styles.tabLink}
              href={`#${tab.id}`}
              key={`link-${tab.id}`}
              role="tab"
            >
              {tab.label}
            </a>
          );
        })}
      </nav>
      <>
        {tabs.map((tab) => {
          const isActive = currentHash ? currentHash === `#${tab.id}` : tab.id === tabs[0]?.id;
          return (
            <section
              aria-current={isActive ? 'page' : undefined}
              aria-labelledby={`tab-${tab.id}`}
              css={styles.tabPanel}
              id={`panel-${tab.id}`}
              key={`panel-${tab.id}`}
              role="tabpanel"
              tabIndex={isActive ? 0 : -1}
            >
              {tab.content}
            </section>
          );
        })}
      </>
    </>
  );
};
